import { useCallback, useMemo, useState } from 'react';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  useToggleModal,
} from '@sbv-clients/ui-shared';

import { DataType, ModalType, ModalTypeConfig } from './types';
import UnScheduledTable from './unscheduled-table';

const useUnscheduledReportModal = () => {
  const [data, setData] = useState<{
    type: ModalType;
    data: DataType[];
  }>({ type: 'scheduled', data: [] });
  const { open, openModal, closeModal } = useToggleModal();
  const modal = useMemo(
    () => (
      <Dialog open={open} fullWidth maxWidth="lg">
        <DialogHeader
          title={ModalTypeConfig[data.type].title}
          onClose={closeModal}
        />
        <DialogContent sx={{ height: '60vh' }}>
          <UnScheduledTable type={data.type} data={data.data} />
        </DialogContent>
      </Dialog>
    ),
    [open, closeModal, data]
  );

  return {
    modal,
    openModal: useCallback(
      (type: ModalType, data: DataType[]) => {
        setData({ type, data });
        openModal();
      },
      [openModal]
    ),
  };
};

export default useUnscheduledReportModal;

export type OpenUnScheduleModalType = ReturnType<
  typeof useUnscheduledReportModal
>['openModal'];
